import { render, staticRenderFns } from "./RetailAdItems.vue?vue&type=template&id=20353be0"
import script from "./RetailAdItems.vue?vue&type=script&lang=js"
export * from "./RetailAdItems.vue?vue&type=script&lang=js"
import style0 from "./RetailAdItems.vue?vue&type=style&index=0&id=20353be0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3507784597/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20353be0')) {
      api.createRecord('20353be0', component.options)
    } else {
      api.reload('20353be0', component.options)
    }
    module.hot.accept("./RetailAdItems.vue?vue&type=template&id=20353be0", function () {
      api.rerender('20353be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RetailAdItems.vue"
export default component.exports